var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail-list",class:_vm.classes},[(!!_vm.images)?_vm._l((_vm.images),function(image){return _c('thumbnail-list-item',{key:image,attrs:{"src":image,"width":_vm.width}})}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }